(() => {
  const init = (root) => {
    if (root.dataset.campaignReady) return;
    root.dataset.campaignReady = 'true';

    const grid = root.querySelector('[data-campaign-grid]');
    const cards = grid ? Array.from(grid.querySelectorAll('.campaign-card')) : [];
    const buttons = Array.from(root.querySelectorAll('[data-campaign-filter]'));

    const applyFilter = (value) => {
      const known = buttons.some((button) => button.dataset.campaignFilter === value);
      const filter = known ? value : 'all';
      buttons.forEach((button) => {
        const active = button.dataset.campaignFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      cards.forEach((card) => {
        card.hidden = filter !== 'all' && card.dataset.type !== filter;
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.campaignFilter));
    });

    root.querySelectorAll('[data-campaign-filter-link]').forEach((link) => {
      link.addEventListener('click', () => applyFilter(link.dataset.campaignFilterLink));
    });

    root.querySelectorAll('[data-campaign-copy]').forEach((button) => {
      const label = button.querySelector('[data-campaign-copy-label]');
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(button.dataset.campaignCopy);
          if (label) label.textContent = 'Copied';
        } catch (error) {
          if (label) label.textContent = 'Select & copy';
        }
        window.setTimeout(() => {
          if (label) label.textContent = 'Copy code';
        }, 2200);
      });
    });

    const dock = root.querySelector('[data-campaign-dock]');
    const hero = root.querySelector('[data-campaign-hero]');
    const shop = root.querySelector('[data-campaign-shop]');
    if (dock && hero && shop && 'IntersectionObserver' in window) {
      const state = { hero: true, shop: false };
      const sync = () => {
        const show = !state.hero && !state.shop;
        dock.classList.toggle('is-visible', show);
        dock.setAttribute('aria-hidden', String(!show));
        const cta = dock.querySelector('a');
        if (cta) cta.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(([entry]) => {
        state.hero = entry.isIntersecting;
        sync();
      }).observe(hero);
      new IntersectionObserver(([entry]) => {
        state.shop = entry.isIntersecting;
        sync();
      }, { threshold: 0.05 }).observe(shop);
    }
  };

  const boot = () => document.querySelectorAll('[data-campaign]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
